import React, { useContext, FC } from 'react';

import CloseIcon from '@material-ui/icons/Close';
import { IconButton } from '@material-ui/core';

import { GlobalContext } from '../../../../../../store';

import { DialogActionsStyled } from './DialogActions.Styles';

const DialogActions: FC = () => {
  const {
    actions: {
      playerEditorModal: { closeModal }
    }
  } = useContext(GlobalContext);

  return (
    <DialogActionsStyled>
      <div className="dialog-actions">
        <IconButton className="close-button" onClick={closeModal}>
          <CloseIcon />
        </IconButton>
      </div>
    </DialogActionsStyled>
  );
};

export default DialogActions;
